
import { useEffect } from "react";
import ListBooks from "../components/Books/ListBooks";
import styles from "./css/ebooks.module.css"


export default function Ebooks({ setHeader }) {

  useEffect(() => {
    setHeader(true);
  }, []);



  return (
    <div className={styles.tableContainer}>
      <ListBooks collectionName="e-books" isVirtual={true} />
    </div>
  );

}